import React, { useEffect, useState } from "react";
import { Badge, Heading, HStack, useToast } from "@chakra-ui/react";
import { DataCollectionModel } from "../services";
import DataTable from "react-data-table-component";
import { formatDate } from "../utils";
import { ViewCOCModal } from "../components";

export default function DataCollections() {
  const [collections, setCollections] = useState([]);
  const [pending, setPending] = useState(true);
  const toast = useToast();

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "yellow";
      case "approved":
        return "green";
      default:
        return "yellow";
    }
  };
  const customStyles = {
    headRow: {
      style: {
        borderBottomWidth: "0px",
      },
    },
    headCells: {
      style: {
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
    rows: {
      style: {
        borderRadius: "15px",
        boxShadow: "1px 2px 6px 0px rgb(0,0,0,0.1)",
        marginBottom: "10px",
        "&:not(:last-of-type)": {
          borderBottomWidth: "0px",
        },
      },
    },
    pagination: {
      style: {
        borderTopWidth: "0px",
      },
    },
  };
  const columns = [
    {
      name: "Technician Name",
      selector: (row) =>
        row.technicianId
          ? row.technicianId.firstName + " " + row.technicianId.lastName
          : "N/A",
    },
    {
      name: "Date Submitted",
      selector: (row) =>
        row.dateCreated ? formatDate(row.dateCreated) : "N/A",
    },
    {
      name: "Status",
      cell: (row) => {
        return (
          <Badge
            colorScheme={getStatusColor(row.status)}
            rounded="full"
            textTransform="capitalize"
            px="1.5"
            pb="0.5"
          >
            {row.status}
          </Badge>
        );
      },
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <ViewCOCModal
            data={row}
            onApproveCollection={onApproveCollection}
            isCollection
          />
        );
      },
    },
  ];

  const onApproveCollection = async (id) => {
    try {
      await DataCollectionModel.approve(id);
      let temp = [...collections];
      let foundId = temp.findIndex((item) => item._id === id);
      if (foundId !== -1) {
        temp.splice(foundId, 1);
        setCollections(temp);
      }
      toast({
        description: "Data approved successfully!",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      toast({
        description: "Something went wrong!",
        status: "error",
        isClosable: true,
      });
    }
  };

  const fetchCollections = async () => {
    try {
      let response = await DataCollectionModel.getWithQuery("?status=pending");
      setCollections(response.data.data);
    } catch (error) {
      toast({
        description: "Something went wrong!",
        status: "error",
        isClosable: true,
      });
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    fetchCollections();
  }, []);

  return (
    <>
      <HStack
        justifyContent="space-between"
        alignItems={{ base: "start", md: "center" }}
        flexDirection={{ base: "column", md: "row" }}
        mb={{ base: 0, md: "2" }}
      >
        <Heading fontSize={{ base: "xl", md: "3xl" }}>Data Collections</Heading>
      </HStack>
      <DataTable
        columns={columns}
        data={collections}
        progressPending={pending}
        keyField="_id"
        customStyles={customStyles}
        responsive
        pagination
      />
    </>
  );
}
